const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://auto-moto-sales-api.web-pixel.ro/api";
export default API_BASE_URL;
